webpackJsonp([1],{

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(138),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(140),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(139),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(142),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 138:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "category"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('div', {
    staticClass: "category-legend",
    domProps: {
      "textContent": _vm._s(_vm.content.name)
    }
  }), _vm._v(" "), (_vm.orphan) ? _c('div', {
    staticClass: "border left"
  }) : _vm._e(), _vm._v(" "), (_vm.orphan) ? _c('div', {
    staticClass: "border right"
  }) : _vm._e(), _vm._v(" "), (_vm.content.children) ? [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "tabs-container"
  }, [_vm._l((_vm.content.children), function(category) {
    return [_c('el-tab-pane', {
      attrs: {
        "label": category.name
      }
    }, [(category.children) ? [_vm._l((category.children), function(subcategory) {
      return [_c('el-row', [_c('div', {
        staticClass: "legend",
        domProps: {
          "textContent": _vm._s(subcategory.name)
        }
      }), _vm._v(" "), _vm._l((subcategory.products), function(product) {
        return [_c('el-col', {
          staticClass: "product",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "inner"
        }, [_c('div', {
          domProps: {
            "textContent": _vm._s(product.title)
          }
        }), _vm._v(" "), _c('router-link', {
          staticClass: "link",
          attrs: {
            "to": {
              name: 'subcategory',
              params: {
                category: _vm.slug,
                subcategory: category.slug,
                subsubcategory: subcategory.slug,
                product: product.slug
              }
            }
          }
        })], 1)])]
      })], 2)]
    })] : [_vm._l((category.products), function(product) {
      return [_c('el-col', {
        staticClass: "product",
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "inner"
      }, [_c('div', {
        domProps: {
          "textContent": _vm._s(product.title)
        }
      }), _vm._v(" "), _c('router-link', {
        staticClass: "link",
        attrs: {
          "to": {
            name: 'subcategory',
            params: {
              category: _vm.slug,
              subcategory: category.slug,
              product: product.slug
            }
          }
        }
      })], 1)])]
    })]], 2)]
  })], 2)])] : [_c('div', [_vm._l((_vm.content.products), function(product) {
    return [_c('el-col', {
      staticClass: "product",
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(product.title)
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'product',
          params: {
            category: _vm.slug,
            product: product.slug
          }
        }
      }
    })], 1)])]
  })], 2)]], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v("NOT FOUND")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "intro"
    }
  }, [_c('br'), _vm._v(" "), _c('el-row', {
    staticClass: "pad-container"
  }, [_c('div', {
    staticClass: "pad-inner-container"
  }, _vm._l((_vm.content), function(category) {
    return _c('el-col', {
      key: category.slug,
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "pad"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": '/static/img/' + category.icon
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": '/' + category.slug
      }
    })], 1)])
  }))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "product"
    }
  }, [_c('div', {
    staticClass: "product-wrapper"
  }, [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('el-row', {
    staticClass: "text-left"
  }, [_c('h1', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.content.title)
    }
  })]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "gallery"
  }, [_c('flickity', {
    ref: "flickity",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, [_vm._l((_vm.content.images), function(img) {
    return [_c('div', {
      staticClass: "carousel-cell"
    }, [_c('img', {
      attrs: {
        "src": _vm.transpileImage(img.src),
        "alt": ""
      }
    })])]
  })], 2)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-left",
    attrs: {
      "span": 11
    }
  }, [_c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "aside",
    attrs: {
      "span": 12,
      "offset": 1
    }
  }, [(this.videoSrc) ? _c('div', {
    staticClass: "video"
  }, [_c('video', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoSrc,
      "type": "video/mp4"
    }
  })])]) : _vm._e()])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isReady),
      expression: "isReady"
    }],
    attrs: {
      "id": "app",
      "element-loading-text": (!_vm.installed) ? 'A descarregar...' : 'A actualizar...'
    }
  }, [_c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "stripe"
  }, [_c('img', {
    attrs: {
      "src": "static/img/stripe.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.svg"
    }
  })])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "info"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [(!_vm.home) ? _c('el-button', {
    attrs: {
      "id": "back",
      "type": "primary",
      "size": "small",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Voltar")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ghost"
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "uppercase",
    attrs: {
      "span": 16,
      "offset": 1
    }
  }, [_vm._v("Lisboa "), _c('a', {
    attrs: {
      "href": "tel:+351219349490"
    }
  }, [_vm._v("219 349 490")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.update
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 21 21",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.553 3.428C15.747 1.615 13.253.49 10.49.49 4.965.49.503 4.965.503 10.49s4.462 10 9.987 10c4.657 0 8.557-3.187 9.663-7.5h-2.6c-1.03 2.913-3.794 5-7.063 5-4.143 0-7.5-3.356-7.5-7.5 0-4.143 3.357-7.5 7.5-7.5 2.07 0 3.925.863 5.282 2.22L11.74 9.24h8.75V.49l-2.937 2.938z",
      "fill": "#F2F2F2"
    }
  }), _c('path', {
    attrs: {
      "d": "M-4.51-4.51h30v30h-30"
    }
  })])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Category_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Category_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Category_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Product_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Product_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Product_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_NotFound_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_NotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_NotFound_vue__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'home',
		component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a
	}, {
		path: '/:category',
		name: 'category',
		component: __WEBPACK_IMPORTED_MODULE_3__views_Category_vue___default.a
	}, {
		path: '/:category/:subcategory/:product',
		name: 'subcategory',
		component: __WEBPACK_IMPORTED_MODULE_4__views_Product_vue___default.a
	}, {
		path: '/:category/:product',
		name: 'product',
		component: __WEBPACK_IMPORTED_MODULE_4__views_Product_vue___default.a
	}, {
		path: '*',
		component: __WEBPACK_IMPORTED_MODULE_5__views_NotFound_vue___default.a
	}]
}));

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(92);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
	content: '',
	products: [],
	categories: [],
	onCategoryView: false,
	lastCategoryView: '',
	onProductView: false,
	isInstalled: false,
	isBootstraped: false,
	isLoading: false
};

var mutations = {
	BOOTSTRAP: function BOOTSTRAP(state, payload) {
		state.content = payload.content;
		state.isBootstraped = true;
	},
	UPDATE: function UPDATE(state, payload) {
		state.content = payload.content;
		state.isLoading = false;
	},
	FETCH_CATEGORIES: function FETCH_CATEGORIES(state, payload) {
		state.categories = payload.categories;
	},
	FETCH_PRODUCTS: function FETCH_PRODUCTS(state, payload) {
		state.products = payload.products;
	},
	PRODUCTS_UPDATE_ALL: function PRODUCTS_UPDATE_ALL(state, payload) {
		state.products = payload;
	},
	ON_CATEGORY_VIEW: function ON_CATEGORY_VIEW(state, payload) {
		state.onCategoryView = true;
	},
	LAST_CATEGORY_VIEW: function LAST_CATEGORY_VIEW(state, payload) {
		state.lastCategoryView = payload.label;
	},
	ON_PRODUCT_VIEW: function ON_PRODUCT_VIEW(state, payload) {
		state.onProductView = true;
	},
	ON_NEUTRAL_PAGE: function ON_NEUTRAL_PAGE(state, payload) {
		state.onCategoryView = false;
		state.onProductView = false;
	},
	LOAD: function LOAD(state, payload) {
		state.isLoading = true;
	},
	UNLOAD: function UNLOAD(state, payload) {
		state.isLoading = false;
	},
	INSTALLED: function INSTALLED(state, payload) {
		state.isInstalled = true;
	}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
	getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
	state: state,
	mutations: mutations
}));

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(143),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flickity__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        options: {
            type: Object,

            default: function _default() {
                return {};
            }
        }
    },

    mounted: function mounted() {
        this.flickity = new __WEBPACK_IMPORTED_MODULE_0_flickity___default.a(this.$el, this.options);
    },
    beforeDestroy: function beforeDestroy() {
        this.flickity.destroy();
        this.flickity = null;
    },


    methods: {
        next: function next(isWrapped, isInstant) {
            this.flickity.next(isWrapped, isInstant);
        },
        previous: function previous(isWrapped, isInstant) {
            this.flickity.previous(isWrapped, isInstant);
        },
        select: function select(index, isWrapped, isInstant) {
            this.flickity.select(index, isWrapped, isInstant);
        },
        selectCell: function selectCell(value, isWrapped, isInstant) {
            this.flickity.selectCell(value, isWrapped, isInstant);
        },
        resize: function resize() {
            this.flickity.resize();
        },
        reposition: function reposition() {
            this.flickity.reposition();
        },
        prepend: function prepend(elements) {
            this.flickity.prepend(elements);
        },
        append: function append(elements) {
            this.flickity.append(elements);
        },
        insert: function insert(elements, index) {
            this.flickity.insert(elements, index);
        },
        remove: function remove(elements) {
            this.flickity.remove(elements);
        },
        playPlayer: function playPlayer() {
            this.flickity.playPlayer();
        },
        stopPlayer: function stopPlayer() {
            this.flickity.stopPlayer();
        },
        pausePlayer: function pausePlayer() {
            this.flickity.pausePlayer();
        },
        unpausePlayer: function unpausePlayer() {
            this.flickity.unpausePlayer();
        },
        destroy: function destroy() {
            this.flickity.destroy();
        },
        reloadCells: function reloadCells() {
            this.flickity.reloadCells();
        },
        getCellElements: function getCellElements() {
            this.flickity.getCellElements();
        },
        data: function data() {
            return __WEBPACK_IMPORTED_MODULE_0_flickity___default.a.data(this.$el);
        },
        on: function on(eventName, listener) {
            this.flickity.on(eventName, listener);
        },
        off: function off(eventName, listener) {
            this.flickity.off(eventName, listener);
        },
        once: function once(eventName, listener) {
            this.flickity.once(eventName, listener);
        }
    }

});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	data: function data() {
		return {
			transition: 'slide-right',
			isLocalhost: Boolean(window.location.hostname === 'localhost' || window.location.hostname === '[::1]' || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/))
		};
	},

	watch: {
		'$route': function $route(to, from) {
			var toDepth = 'home' === to.name ? 0 : to.path.split('/').length;
			var fromDepth = from.path.split('/').length;
			this.transition = toDepth < fromDepth ? 'slide-left' : 'slide-right';
		}
	},
	computed: {
		installed: function installed() {
			return this.$store.state.isInstalled;
		},
		bootstraped: function bootstraped() {
			return this.$store.state.isBootstraped;
		},
		loading: function loading() {
			return this.$store.state.isLoading;
		},
		isReady: function isReady() {
			return !this.installed || this.installed && !this.bootstraped || this.installed && this.loading;
		},
		home: function home() {
			return '/' === this.$route.path;
		}
	},
	methods: {
		back: function back() {
			this.$router.go(-1);
		},
		update: function update() {
			if (navigator.onLine) {
				this.$store.dispatch('update');
			} else {
				this.$notify.error({
					title: 'Sem ligação',
					message: 'Verifique a sua ligação à Internet.'
				});
			}
		},
		readyToGo: function readyToGo(event) {
			this.$store.dispatch('installed');
		}
	},
	created: function created() {
		var _this = this;

		if (this.isLocalhost) {
			setTimeout(function () {
				return _this.$store.dispatch('installed');
			}, 5000);
		}

		setTimeout(function () {
			if (!_this.isReady) {
				_this.$store.dispatch('installed');
				_this.$store.dispatch('bootstrap');
				_this.$store.dispatch('unload');
			}
		}, 10000);
	}
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			slug: this.$route.params.category
		};
	},

	computed: {
		content: function content() {
			return this.$store.getters.content[this.slug];
		},
		orphan: function orphan() {
			return this.content.products ? false : true;
		}
	},
	methods: {
		handleClick: function handleClick(tab, event) {
			this.$store.commit('LAST_CATEGORY_VIEW', tab);
		}
	},
	created: function created() {
		this.$store.commit('ON_CATEGORY_VIEW');
	}
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'home',
	data: function data() {
		return {
			pos: 0
		};
	},
	created: function created() {
		this.$store.commit('ON_NEUTRAL_PAGE');
		if (!this.$store.getters.isBootstraped) {
			this.$store.dispatch('bootstrap');
		}
	},

	computed: {
		content: function content() {
			return this.$store.state.content;
		}
	}
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_flickity__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity_imagesloaded__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flickity_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_flickity_imagesloaded__);





var URL = 'https://app.scada.pt';

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Flickity: __WEBPACK_IMPORTED_MODULE_0_vue_flickity___default.a
	},
	data: function data() {
		return {
			category: this.$route.params.category,
			subcategory: this.$route.params.subcategory,
			subsubcategory: this.$route.params.subsubcategory,
			slug: this.$route.params.product,
			flickityOptions: {
				initialIndex: 0,
				prevNextButtons: false,
				pageDots: false,
				cellAlign: 'center',
				autoPlay: 4000,
				pauseAutoPlayOnHover: false,
				contain: true,
				setGallerySize: false,
				imagesLoaded: true
			},
			isLocalhost: Boolean(window.location.hostname === 'localhost' || window.location.hostname === '[::1]' || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/))
		};
	},

	computed: {
		content: function content() {

			var category = this.$store.getters.content[this.category];

			if (this.subcategory) {
				if (this.subsubcategory) {
					return category.children[this.subcategory].children[this.subsubcategory].products[this.slug];
				} else {
					return category.children[this.subcategory].products[this.slug];
				}
			} else {
				return category.products[this.slug];
			}
		},
		videoSrc: function videoSrc() {

			var src = '';

			if (this.category === 'cadeiras-elevador') src = this.category;

			if (this.slug === 'pool-star' || this.slug === 'v64' || this.slug === 'v65' || this.slug === 'plg7' || this.slug === 'plk8' || this.slug === 'silver' || this.slug === 'angular' || this.slug === 'e07-easy-move' || this.slug === 'serie-lr' || this.slug === 'serie-vm' || this.slug === 'sl-250' || this.slug === 'steppy' || this.slug === 't09-roby' || this.slug === 'e10-ecovimec') src = this.slug;

			return src ? '/static/vids/' + src + '.mp4' : false;
		}
	},
	methods: {
		transpileImage: function transpileImage(src) {
			return this.isLocalhost ? src : src.replace('https://www.scada.pt/wp-content', '');
		}
	},
	created: function created() {
		this.$store.commit('ON_PRODUCT_VIEW');
	},
	mounted: function mounted() {
		this.$nextTick(function () {});
	}
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



var baseURL = 'https://scada.pt/wp-json/catalog';

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = baseURL;

/* harmony default export */ __webpack_exports__["a"] = ({

	bootstrap: function bootstrap(cb) {

		var query = '/bootstrap';

		if ('caches' in window) {

			caches.match(baseURL + query).then(function (res) {

				if (res) {
					console.log('CONTENT\'S IN CACHE!');

					res.json().then(function (data) {
						return cb(data);
					});
				}
			});
		}

		if (navigator.onLine) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(query).then(function (res) {
				return cb(res.data);
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	update: function update(cb) {

		var query = '/bootstrap';

		if ('caches' in window) {

			caches.match(baseURL + query).then(function (res) {

				if (res) {
					console.log('CONTENT\'S IN CACHE!');

					res.json().then(function (data) {
						return cb(data);
					});
				}
			});
		}

		if (navigator.onLine) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(query).then(function (res) {
				return cb(res.data);
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	getCategories: function getCategories(cb) {

		var query = '/categories';

		if ('caches' in window) {

			caches.match(baseURL + query).then(function (res) {

				if (res) {
					console.log('CATEGORIES IN CACHE!');

					res.json().then(function (data) {
						return cb(data);
					});
				}
			});
		}

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(query).then(function (res) {
			return cb(res.data);
		}).catch(function (err) {
			console.log(err);
		});
	},

	getProducts: function getProducts(cb) {

		var query = "/products";

		if ('caches' in window) {

			caches.match(baseURL + query).then(function (res) {

				if (res) {
					console.log('PRODUCTS IN CACHE!');

					res.json().then(function (data) {
						return cb(data);
					});
				}
			});
		}

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/users/1').then(function (res) {
			return cb(res.data);
		}).catch(function (err) {
			console.log(err);
		});
	}
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_theme_index_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_theme_index_css__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.debug = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devTools = true;

var state = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state;


if (!state.bootstraped) {
  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
}

var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

window.vm = vm;

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bootstrap", function() { return bootstrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCategories", function() { return getCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProducts", function() { return getProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onCategoryView", function() { return onCategoryView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onPostItem", function() { return onPostItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onNeutralPage", function() { return onNeutralPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unload", function() { return unload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installed", function() { return installed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(89);


var bootstrap = function bootstrap(_ref) {
    var commit = _ref.commit;

    commit('LOAD');
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].bootstrap(function (content) {
        commit('BOOTSTRAP', { content: content });
        commit('UNLOAD');
    });
};

var update = function update(_ref2) {
    var commit = _ref2.commit;

    commit('LOAD');
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update(function (content) {
        commit('UPDATE', { content: content });
        commit('UNLOAD');
    });
};

var getCategories = function getCategories(_ref3) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCategories(function (categories) {
        commit('FETCH_CATEGORIES', { categories: categories });
    });
};

var getProducts = function getProducts(_ref4) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getProducts(function (products) {
        commit('FETCH_PRODUCTS', { products: products });
    });
};

var onCategoryView = function onCategoryView(_ref5) {
    var commit = _ref5.commit;

    commit('ON_CATEGORY_VIEW');
};

var onPostItem = function onPostItem(_ref6) {
    var commit = _ref6.commit;

    commit('ON_POST_VIEW');
};

var onNeutralPage = function onNeutralPage(_ref7) {
    var commit = _ref7.commit;

    commit('ON_NEUTRAL_VIEW');
};

var load = function load(_ref8) {
    var commit = _ref8.commit;

    commit('LOAD');
};

var unload = function unload(_ref9) {
    var commit = _ref9.commit;

    commit('UNLOAD');
};

var installed = function installed(_ref10) {
    var commit = _ref10.commit;

    commit('INSTALLED');
};

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "content", function() { return content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "categories", function() { return categories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "products", function() { return products; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onCategoryView", function() { return onCategoryView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLastCategoryView", function() { return getLastCategoryView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onProductView", function() { return onProductView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInstalled", function() { return isInstalled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBootstraped", function() { return isBootstraped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });


var content = function content(state) {
	return state.content;
};

var categories = function categories(state) {
	return state.categories;
};

var products = function products(state) {
	return state.products;
};

var onCategoryView = function onCategoryView(state) {
	return state.onCategoryView;
};

var getLastCategoryView = function getLastCategoryView(state) {
	return state.lastCategoryView;
};

var onProductView = function onProductView(state) {
	return state.onProductView;
};

var isInstalled = function isInstalled(state) {
	return state.isBootstraped;
};

var isBootstraped = function isBootstraped(state) {
	return state.isBootstraped;
};

var isLoading = function isLoading(state) {
	return state.isLoading;
};

/***/ })

},[90]);


// WEBPACK FOOTER //
// static/js/app.f846e99dd5d2df1dc5dc.js